import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! RESPONSIBLE TEAM: team-data-foundations }}",{ moduleName: "embercom/components/app-framework/messenger-apps/canvas.hbs" })